import { z } from 'zod';
import { LIMITS } from '../constants.js';

export const usernameSchema = z
  .string()
  .trim()
  .min(LIMITS.usernameMin)
  .max(LIMITS.usernameMax)
  .regex(/^[a-z0-9_.]+$/i, 'only letters, digits, dot and underscore')
  .transform((value) => value.toLowerCase());

export const passwordSchema = z.string().min(8).max(200);

export const registerSchema = z.object({
  username: usernameSchema,
  password: passwordSchema,
  displayName: z.string().trim().min(1).max(LIMITS.displayNameMax),
  inviteCode: z.string().trim().max(64).optional(),
});
export type RegisterInput = z.infer<typeof registerSchema>;

export const loginSchema = z.object({
  username: usernameSchema,
  password: z.string().min(1).max(200),
});
export type LoginInput = z.infer<typeof loginSchema>;

export const refreshSchema = z.object({ refreshToken: z.string().min(10) });
export type RefreshInput = z.infer<typeof refreshSchema>;

export const changePasswordSchema = z.object({
  currentPassword: z.string().min(1),
  newPassword: passwordSchema,
});

export interface AuthTokens {
  accessToken: string;
  /** Seconds until `accessToken` expires. */
  expiresIn: number;
  /**
   * Fehlt, wenn der Client die Sitzung über den `HttpOnly`-Keks führt (Kopf
   * `x-initiative-sitzung`) und der Server ihn setzen konnte. Ältere Clients
   * ohne den Kopf bekommen ihn wie bisher.
   */
  refreshToken?: string;
}

export interface AuthSession extends AuthTokens {
  user: import('./user.js').SelfUserDto;
}
